import { classNames } from '@dimjs/utils';
import { TPlainObject } from '@flatbiz/utils';
import { cloneElement, CSSProperties, ReactElement, ReactNode } from 'react';

export interface NativeProps<S extends string = never> {
  className?: string;
  style?: CSSProperties & Partial<Record<S, string>>;
}

export type VarProps<S extends string = never> = Partial<Record<S, string>>;

export interface CommonProps<S extends TPlainObject = TPlainObject> {
  className?: string;
  style?: CSSProperties & Partial<S>;
}
export interface CommonPropsWithChildren<S extends TPlainObject = TPlainObject> {
  className?: string;
  style?: CSSProperties & Partial<S>;
  children?: ReactNode | undefined;
}

export function withNativeProps<P extends NativeProps>(props: P, element: ReactElement<P>) {
  const p = {
    ...element.props,
  };
  if (props.className) {
    p.className = classNames(element.props.className as string, props.className);
  }
  if (props.style) {
    p.style = {
      ...p.style,
      ...props.style,
    };
  }
  return cloneElement<P>(element, p);
}
